import { TextMessageSidebarHeader } from "@/core/components/text-message-sidebar-header";
import { SimpleSidebar } from "@/core/components/ui/simple-sidebar";
import { IMostRecentTextMessage } from "@/text-messages/text-messages";
import TextMessagesSidebar from "@/text-messages/text-messages-sidebar";

export const DashboardSidebar = ({
  isOpen,
  selectedItem,
  setIsSidebarOpen,
}: {
  isOpen: boolean;
  selectedItem: IMostRecentTextMessage | null;
  setIsSidebarOpen: (open: boolean) => void;
}) => (
  <SimpleSidebar>
    <div className="flex h-full flex-col overflow-hidden">
      <TextMessageSidebarHeader
        selectedItem={selectedItem}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <div className="flex-1 overflow-hidden">
        <TextMessagesSidebar textMessage={selectedItem} isOpen={isOpen} />
      </div>
    </div>
  </SimpleSidebar>
);
